module.exports = __webpack_public_path__ + "static/reto-zapopan@2x-370114860cc0c9e43b930ca40413e3c5.png";